
function loadImage(d) {

  let img = '';
  try {
   img = require("../assets/data/icons_witterand/" + d['oorzaak effect impact'].replaceAll('/','') + ".png");
  }
  catch (e) {
    img = require("../assets/data/icons_witterand/Bermbranden.png");
  }

  return img;

}

export default loadImage;
